function optionsSuccess(options, ...data) {
  if (options.success) {
    if (data) {
      options.success(...data);
    } else {
      options.success();
    }
  }
}

module.exports = optionsSuccess;



// WEBPACK FOOTER //
// ./static/js/v0/utilities/options-success.js